import { DatePipe, Location } from "@angular/common";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { environment } from "src/environments/environment";
import { TransactionStatusPipe } from "src/app/pipes/transaction-status.pipe";
import { ApiService } from "src/app/services/api.service";
import { DataTransferService } from "src/app/services/data-transfer.service";

@Component({
  selector: "app-transaction-template-detail",
  templateUrl: "./transaction-template-detail.component.html",
  styleUrls: ["./transaction-template-detail.component.scss"],
  providers: [DatePipe, TransactionStatusPipe],
})
export class TransactionTemplateDetailComponent implements OnInit {
  mediaURL = environment.MEDIA_SERVICE;
  title: string;
  templateDetail: any;
  templateId: string;

  public screen: ElementRef;
  @ViewChild("screen") set content(content: ElementRef) {
    if (content) {
      this.screen = content;
    }
  }
  constructor(
    private api: ApiService,
    public modalRef: BsModalRef,
    public dataService: DataTransferService,
    private location: Location
  ) {
    this.location.subscribe((popStateEvent) => {
      if (this.modalRef) {
        this.modalRef.hide();
      }
    });
  }

  ngOnInit() {
    this.getTemplateDetails();
  }

  async getTemplateDetails() {
    const response: any = await this.api.get(
      `payment/money/template/${this.templateId}`,
      true
    );
    if (response) {
      this.templateDetail = response.data;
    } else {
      this.modalRef.hide();
    }
  }

  onMapReady(map?: any): void {
    if (map) {
      map.setOptions({
        streetViewControl: false,
      });
    }
  }
}
